import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { EventGetModel } from 'src/app/interfaces/interfaces';
import { DashboardLogicService } from 'src/app/logic/dashboard.service';
import { EventLogicService } from 'src/app/logic/event-service';
import { PassDataService } from 'src/app/services/pass-data.service';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})
export class EventListComponent implements OnInit {

  eventsList$: Observable<EventGetModel[]> = new Observable<
  EventGetModel[]
  >();

  deleteventId: string = '';

  page: number = 1;

  constructor(
    private passDataService: PassDataService,
    private eventLogicService: EventLogicService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.eventsList$ = this.passDataService.getAllEvents();
  }

  onAddButtonClick() {
    this.router.navigate(['/page/add-event'], {
      state: { isAdd: true, isEdit: true, isView: false },
    });
  }

  receivedAction(e: any) {
    e.isAddSloka &&
      this.router.navigate(['/page/add-event/'], {
        state: {
          isAddSloka: true,
          isAdd: true,
          isEdit: true,
          isView: false,
          data: e.data,
        },
      });

    e.isEdit &&
      this.router.navigate([`/page/events/${e.data.title}`], {
        state: {
          isAddSloka: false,
          isAdd: false,
          isEdit: true,
          isView: false,
          data: e.data,
        },
      });

    e.isView &&
      this.router.navigate([`/page/events/${e.data.title}`], {
        state: {
          isAddSloka: false,
          isAdd: false,
          isEdit: false,
          isView: true,
          data: e.data,
        },
      });

    e.isDelete &&
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Are you sure to delete this event?',
        isOk: false,
        isDelete: true,
        response: '',
      });

    e.isDelete &&
      this.passDataService
        .getPopupAction()
        .pipe(
          filter((a) => {
            return (a != '' || a != null || typeof a != 'undefined');
          }),
          map((b) => b == 'delete'),
          filter((c) => c),
          switchMap(async (d) => {
            //console.log(d)
            return await this.eventLogicService.deleteEventLogic(e?.data)
        }
          ),
          take(1)
        )
        .subscribe((v: any) => {
          //console.log(v)
          v.message == 'Event deleted succesfully' &&
            this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe() &&
            this.passDataService.setPopup({
              isPopup: true,
              message: 'Event info deleted successfully!',
              isOk: true,
              isDelete: false,
              response: '',
            });
        });
  }


}
